import { render } from "./AdminLeaveReport.vue?vue&type=template&id=2763bd9c&scoped=true"
import script from "./AdminLeaveReport.vue?vue&type=script&lang=js"
export * from "./AdminLeaveReport.vue?vue&type=script&lang=js"

import "./AdminLeaveReport.vue?vue&type=style&index=0&id=2763bd9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2763bd9c"]])

export default __exports__